// useUniversities — fetch 64 universities from backend, cache in module scope.
import { useEffect, useState } from 'react';
import { listUniversities } from '../lib/cmsApi';

let _cache = null;
let _pending = null;
const _subscribers = new Set();

async function _load() {
  if (_cache) return _cache;
  if (!_pending) {
    _pending = listUniversities()
      .then((d) => { _cache = Array.isArray(d) ? d : []; _pending = null; _subscribers.forEach((cb) => cb()); return _cache; })
      .catch((_) => { _pending = null; _cache = []; return _cache; });
  }
  return _pending;
}

export function invalidateUniversities() {
  _cache = null;
  _pending = null;
  _subscribers.forEach((cb) => cb());
}

export function useUniversities(fallback = []) {
  const [items, setItems] = useState(() => _cache || fallback);
  useEffect(() => {
    let cancelled = false;
    const notify = () => { if (!cancelled) setItems(_cache || fallback); };
    _subscribers.add(notify);
    _load().then(() => { if (!cancelled) notify(); });
    return () => { cancelled = true; _subscribers.delete(notify); };
    // eslint-disable-next-line
  }, []);
  return items;
}

export function useUniversity(slug, fallback = null) {
  const list = useUniversities();
  return list.find((u) => u.slug === slug) || fallback;
}
